import { render, staticRenderFns } from "./SpriteView.vue?vue&type=template&id=4c36ada0&"
import script from "./SpriteView.vue?vue&type=script&lang=js&"
export * from "./SpriteView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports